import axios from "axios";
import { localStorageItem } from "../../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";
import { DON_VI_CONG_TAC_ID, SEARCH_OBJECT_MAX_SIZE } from "../../../utils/Constant";

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"];

export const getListEmployee = () => {
    let params = {
        ...SEARCH_OBJECT_MAX_SIZE,
        donViCongTacId: DON_VI_CONG_TAC_ID
    }
    let url = `${API_PATH}/member-set/search-employee`;
    return axios.get(url, { params });
}

export const searchHospitalCouncil = (year: number | string) => {
    let params = {
        ...SEARCH_OBJECT_MAX_SIZE,
        year
    };
    let url = `${API_PATH}/member-set/search`;
    return axios.get(url, { params });
}

export const saveHospitalCouncil = (data: any) => {
    let url = `${API_PATH}/member-set`;
    return axios.post(url, data);
}

export const createAccountMember = (data: any) => {
    let url = `${API_PATH}/users`;
    return axios.post(url, data);
}

